"use strict";

const DefaultColumnComponent = require("../default/DefaultColumnComponent");
const Renderer = require("./GroupingColumnRenderer");
const _ = require("lodash");

class GroupingColumnComponent extends DefaultColumnComponent {
    constructor(entity) {
        super(entity);

        this._entity = entity || {}; //it is a grouping entity
        this._isGroupHeader = Boolean(this._entity.isGroupHeader);

        this._replacementValue = _.get(this._entity, '_replacementValue', null);

        this._data = this._entity.properties || {};
        this._value = this._data.count;

        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    getTitle() {
        return this._data.title;
    }

    toggleGroup(state) {
        state = _.isUndefined(state) ? !this._expanded : !!state;
        if (state !== this._expanded) {
            this._expanded = state;
            this._entity.toggleExpand(state);
        }
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = GroupingColumnComponent;
